import { render, staticRenderFns } from "./paycustomers.vue?vue&type=template&id=b6c022a0&scoped=true&"
import script from "./paycustomers.vue?vue&type=script&lang=js&"
export * from "./paycustomers.vue?vue&type=script&lang=js&"
import style0 from "./paycustomers.vue?vue&type=style&index=0&id=b6c022a0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6c022a0",
  null
  
)

export default component.exports